import type { Ctx } from "../../types";
import { Action, invalidate } from "gg-wf-scripts";
import { toast } from "../../toast";

export const job_set_unpaid: Action<Ctx, { id?: string }> = async (
  { sb },
  data,
  params,
) => {
  const job_opening_id = data.id ?? params.get("id");
  if (!job_opening_id) {
    return { ok: false, error: "Missing id on row record or in URL" };
  }

  const { data: updated, error } = await sb
    .from("job_openings")
    .update({ pay_status: "unpaid" })
    .eq("id", job_opening_id)
    .is("deleted_at", null)
    .select("id")
    .maybeSingle();
  if (error) {
    toast({ variant: "error", text: "Pay update failed. Try again" });
    return { ok: false, error: error.message };
  }
  if (!updated) {
    toast({ variant: "warning", text: "Job not found." });
    return { ok: false, error: "Job not found" };
  }
  invalidate("jobs");
  toast({ variant: "success", text: "Job marked unpaid." });
  return { ok: true };
};
